<div class="field-checkbox mb-0">
  <div class="flex flex-column">
    <!-- TODO refine with reactive forms here -->
    <div class="flex align-items-start">
      <p-checkbox
        *ngIf="showCheckbox"
        [ngModel]="isOrderConfirmed$ | async"
        (ngModelChange)="onConfirmChange($event)"
        [binary]="true"
        [disabled]="disabled"
        inputId="order-confirmation-checkbox-{{ uuid }}"
        data-cy="order-wizard-confirmation-checkbox"
        [ngClass]="{
          'ng-invalid': (isOrderConfirmed$ | async) === false,
          'ng-dirty': isDirty,
          'ng-touched': isTouched
        }"
      ></p-checkbox>
      <label
        for="order-confirmation-checkbox-{{ uuid }}"
        class="wizard-confirmation-label p-checkbox-label small text-black-400"
        [ngClass]="{ 'required-label': showCheckbox }"
        data-cy="order-wizard-confirmation-checkbox-label"
      >
        <span class="text-error-base mr-1 font-medium"> Important: </span>
        This information is only an estimate. Your insurance will determine actual member liability at the time your
        claim is processed. You are responsible for all deductibles, co-payments, co-insurance amounts or any other
        patient responsibility indicated by your insurance carrier, which are not otherwise covered by supplemental
        insurance.
      </label>
    </div>
    <div *ngIf="(isDirty || isTouched) && (isOrderConfirmed$ | async) === false" class="mt-2">
      <small class="p-error block" data-cy="error-required">Confirmation is required</small>
    </div>
  </div>
</div>
